import { CUSTOMER_FORM_MESSAGES, CustomerFormMessages } from "./customer-form.messages";
import { PLAN_MANAGEMENT_MESSAGES, PlanManagementMessages } from "./plan-management.messages";
import { PLANS_TABLE_MESSAGES, PlansTableMessages } from "./plans-table.messages";
import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { ADRESS_MESSAGES, AddressMessages } from "../address.messages";
import { DOCUMENT_MESSAGES, DocumentMessages } from "../document-messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";
import { PHONE_MESSAGES, PhoneMessages } from "../phone-messages";

export type CustomerMessages = ActionButtonMessages &
  AddressMessages &
  PhoneMessages &
  SidebarMessages &
  DocumentMessages &
  CustomerFormMessages &
  PlansTableMessages &
  PlanManagementMessages & {
    pageTitle: string;
    cardTitle: string;
    breadCrumbTitle: string;
    categorySectionTitle: string;

    //Tabs
    generalInformationTabLabel: string;
    configurationTabLabel: string;
    subscriptionManagementTabLabel: string;

    noPlanAdded: string;
  };

export const CUSTOMER_DETAILS_MESSAGES: CustomerMessages = {
  breadCrumbTitle: "Empresa",
  pageTitle: "Dados da Empresa",
  cardTitle: "Teste",
  categorySectionTitle: "Categoria da Empresa",

  //Tabs
  generalInformationTabLabel: "Informações gerais",
  configurationTabLabel: "Configurações",
  subscriptionManagementTabLabel: "Gerenciamento de Assinaturas",

  noPlanAdded: "Nenhum plano foi adicionado",

  ...CUSTOMER_FORM_MESSAGES,
  ...ACTION_BUTTON_MESSAGES,
  ...SIDEBAR_MESSAGES,
  ...ADRESS_MESSAGES,
  ...PHONE_MESSAGES,
  ...DOCUMENT_MESSAGES,
  ...PLANS_TABLE_MESSAGES,
  ...PLAN_MANAGEMENT_MESSAGES,
};
